import styled from 'styled-components'

const Padding = styled.div`
  padding: ${(p) => (p.one ? '1em' : p.three ? '3em' : '1em')};
`

export default Padding
